(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .factory('AnalyticsConfig', AnalyticsConfig);

  // @ngInject
  function AnalyticsConfig() {
    var MET_SESSIONS = 'sessions',
        MET_CHECKOUTS = 'checkouts',
        MET_CONVERSION_RATE = 'conversionRate',

        MET_REVENUE = 'revenue',
        MET_USERS = 'users',
        MET_REVENUE_PER_VISIT = 'revenuePerVisit',

        MET_RETURNS = 'returnUnits',
        MET_ORDERS = 'orderUnits',
        MET_RETURN_RATE = 'returnRate';

    var TAB_CONVERSION = 'conversion',
        TAB_REVENUE = 'revenue',
        TAB_RETURNS = 'returns',
        TAB_OVERVIEW = 'overview';

    return {
      getTabs : getTabs,
      summaryMetrics : summaryMetrics,
      chartMetrics : chartMetrics,
      viewType : viewType
    };

    function defaultOrder(tab) {
      switch (tab) {
        case TAB_CONVERSION: return [MET_SESSIONS, MET_CHECKOUTS, MET_CONVERSION_RATE];
        case TAB_REVENUE: return [MET_REVENUE, MET_USERS, MET_REVENUE_PER_VISIT];
        case TAB_RETURNS: return [MET_ORDERS, MET_RETURNS, MET_RETURN_RATE];
        case TAB_OVERVIEW: return [MET_CONVERSION_RATE, MET_REVENUE_PER_VISIT, MET_RETURN_RATE];
      }
    }

    function getTabs(experimentType) {
      if (experimentType) {
        return [TAB_OVERVIEW, TAB_CONVERSION, TAB_REVENUE, TAB_RETURNS];
      } else {
        return [TAB_CONVERSION];
      }
    }

    function summaryMetrics(experimentType) {
      if (experimentType) {
        return {
          conversion : defaultOrder(TAB_CONVERSION),
          revenue : defaultOrder(TAB_REVENUE),
          returns : defaultOrder(TAB_RETURNS),
          overview : defaultOrder(TAB_OVERVIEW)
        };
      } else {
        return {
          // no conversion summary on live view
          conversion : [MET_SESSIONS, MET_CHECKOUTS]
        };
      }
    }

    function chartMetrics(experimentType) {
      if (experimentType) {
        return {
          conversion : kpiToTop(defaultOrder(TAB_CONVERSION)),
          revenue : kpiToTop(defaultOrder(TAB_REVENUE)),
          returns : kpiToTop(defaultOrder(TAB_RETURNS)),
          overview : defaultOrder(TAB_OVERVIEW)
        };
      } else {
        return {
          conversion : defaultOrder(TAB_CONVERSION)
        };
      }
    }

    function viewType(experimentType) {
      return experimentType ? 'experiment' : 'live';
    }

    function kpiToTop(metrics) {
      var kpi = metrics.pop();
      metrics.unshift(kpi);
      return metrics;
    }
  }

})();
